var _config, _Level;
var ApiLevel;
(function(ApiLevel) {
    ApiLevel[ApiLevel["Trigger"] = 2] = "Trigger";
    ApiLevel[ApiLevel["Call"] = 1] = "Call";
})(ApiLevel || (ApiLevel = {}));
const Level = Symbol('Api level refs');
function setLevelRef(config, level) {
    var ref;
    (ref = (_config = config)[_Level = Level]) !== null && ref !== void 0 ? ref : _config[_Level] = {};
    config[Level][level] = {};
}
function getLevelRef(config, level) {
    var ref;
    return (ref = config[Level]) === null || ref === void 0 ? void 0 : ref[level];
}

export { ApiLevel, getLevelRef, setLevelRef };
